import { render, staticRenderFns } from "./OrderPlaceField.vue?vue&type=template&id=b23a9084&scoped=true&"
import script from "./OrderPlaceField.vue?vue&type=script&lang=js&"
export * from "./OrderPlaceField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b23a9084",
  null
  
)

export default component.exports